import React, {useState} from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Form from 'react-bootstrap/Form';

const NewHireKitItem = ({ item, inventory, setSize, remove, edit, currentSize }) => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;

  const sizeChange = (e) => {
    setSize(item.nhkiId, e.target.value);
  }


  const formatPantsSize = (sizeName) => {
    var isFour = /^\d{4}$/.test(sizeName);
    if (isFour) {
      return sizeName.substring(0, 2) + "x" + sizeName.substring(2);
    } else {
      return sizeName;
    }
  }


  return (
    <Container className="mt-5" style={{ border: "1px solid #CCCCCC", padding: 10 }}>
      <Row>
        <Col sm={2}>
          <div style={{ display: "inline-block", position: "relative" }}>
            <img className="bg-image" src={item.frontModelImage} width={'100%'}></img>
            {item.logos.map((logo, i) => (
              <img className="logo-image" src={apiUrl + logo.imageUrl} width={logo.width + '%'} style={{ left: logo.x + '%', top: logo.y + '%', transform: 'rotate(' + logo.rotate + 'deg)' }}></img>
            )
            )}


          </div>
        </Col>
        <Col sm={10}>
          <div style={{ position: "relative" }}>
            <div style={{ position: "absolute", right: 0, alignItems: "flex-end", display: "flex", flexDirection: "row-reverse" }}>
              {edit && (<Button size="sm" variant='danger' onClick={() => remove(item)}>Remove From New Hire Kit</Button>)}
            </div>
            <div className="title">{item.title}</div>
            <div className="price">${(4 + item.price).toFixed(2)}</div>
            <div className="color-title">
              Color: {item.colorName} <img src={`https://cdnm.sanmar.com/swatch/gifs/${item.squareImageName}`} height={18} />
            </div>
            <div className="color-title">
              Decorations:
              <div style={{ padding: 5, marginLeft: 20 }}>
                {item.logos.map(logo => (
                  <div>
                    {logo.decoName} {logo.locName} {logo.decoType}
                  </div>
                ))}
              </div>

            </div>
            <div>
              <Form.Group className="mb-3" controlId="state">
                {edit && (
                <select
                  name="size"
                  onChange={(e) => {
                    sizeChange(e);
                  }}
                >
                  <option value="">Select a Size</option>
                  {item.sizes.map(size => {
                    var inv = inventory.find(item => item.uniqueKey == size.uniqueKey);
                    if (inv && inv.quantity == 0) {
                      return (
                        <option value={size.productId} disabled>{formatPantsSize(size.sizeName)}</option>
                      );
                    } else {
                      if (inv && inv.quantity < 30) {
                        return (
                          <option value={size.productId}>{formatPantsSize(size.sizeName) + "Low Stock: " + inv.quantity}</option>

                        );

                      } else {

                        return (
                          <option value={size.productId}>{formatPantsSize(size.sizeName)}</option>
                        );
                      }
                    }

                  })}



                </select>)}
                {!edit && (
                  <div>Size: {currentSize}</div>
                )}
              </Form.Group>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NewHireKitItem;